import { IApplicationState } from '../../types/redux';

export function selectLargePinsZoom(state: IApplicationState): number {
  return state.infrastructure.config.largePinsZoom;
}
